const SEMANTIC_CELL_SKINS = new Set([
    'error',
    'warning',
    'success'
]);
export const semanticSkinOnly = (skin)=>skin != null && SEMANTIC_CELL_SKINS.has(skin) ? skin : undefined;
export const tableWeight = (weight)=>weight === 'bold' ? 'normal' : weight;
